module.exports = __webpack_public_path__ + "img/logoActive.504a7a9a.png";